import { AxiosResponse } from 'axios';
import { LogTTE } from '../../entities/LogTTE';
import { LogTTEPengetahuan } from '../../entities/LogTTEPengetahuan';

export class LogTTEDataMapper {
  public convertListLogTTEData(result: AxiosResponse<any>): LogTTE[] {
    const { data } = result.data;

    let logTTE: LogTTE[] = [];

    data.map((d: any) => {
      return logTTE.push(
        new LogTTE(
          d.total,
          d.diproses,
          d.berhasil,
          d.gagal,
          d.judul_pelatihan,
          result.data.pagination.total_rows,
          d.created_at,
          d.updated_at,
          d.waktu_mulai,
          d.waktu_selesai
        )
      );
    });

    return logTTE;
  }

  public convertListLogTTEPengetahuanData(
    result: AxiosResponse<any>
  ): LogTTEPengetahuan[] {
    const { data, pagination } = result.data;

    return data.map(
      (d: any) =>
        new LogTTEPengetahuan(
          d.id,
          d.pengetahuan_id,
          d.title,
          d.note,
          d.total,
          d.diproses,
          d.berhasil,
          d.gagal,
          d.jadwal_mulai,
          d.jadwal_selesai,
          d.created_at,
          d.updated_at,
          pagination.total_rows
        )
    );
  }
}
